module.exports = __webpack_public_path__ + "pn.svg?9de82ae3056dab1d58f79e36c0d4741a";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/pn.svg
// module id = 914
// module chunks = 27